/* ⚠️ GENERATED from app/services/memories.ts by gen-twins.mjs — edit the TypeScript, not this. */
/* ═══════════════════════════════════════════════════════════════════════════
   🕰 memories.ts — "On this day": what you posted on today's date in years past.

   Asked of your own posts, one day-long window per year back (your local day),
   newest year first. Plain logic: the clients run the queries, this says which
   windows to ask for and how to group what comes back.
   ═══════════════════════════════════════════════════════════════════════════ */
export const MEMORY_YEARS = 8;

/** The windows to ask for: [{ years, from, to }] — your local calendar day, N years ago. */
export function memoryWindows(nowMs, years = MEMORY_YEARS) {
  const now = new Date(nowMs);
  const out = [];
  for (let y = 1; y <= years; y += 1) {
    const from = new Date(now.getFullYear() - y, now.getMonth(), now.getDate());
    /* 29 Feb in a year that had none rolls to 1 Mar — skip it rather than show the wrong day */
    if (from.getMonth() !== now.getMonth()) continue;
    const to = new Date(now.getFullYear() - y, now.getMonth(), now.getDate() + 1);
    out.push({
      years: y,
      from: from.getTime(),
      to: to.getTime()
    });
  }
  return out;
}
const msOf = t => {
  if (!t) return 0;
  if (typeof t === 'number') return t;
  if (typeof t.toMillis === 'function') return t.toMillis();
  if (typeof t.seconds === 'number') return t.seconds * 1000;
  if (t instanceof Date) return t.getTime();
  return 0;
};

/** Group posts into the windows they fall in, newest year first, empty years left out. */
export function onThisDay(posts, nowMs, years = MEMORY_YEARS) {
  const wins = memoryWindows(nowMs, years);
  const out = [];
  for (const w of wins) {
    const ps = (posts || []).filter(p => {
      const t = msOf(p && p.timestamp);
      return t >= w.from && t < w.to;
    }).sort((a, b) => msOf(a.timestamp) - msOf(b.timestamp));
    if (ps.length) out.push({
      years: w.years,
      posts: ps
    });
  }
  return out;
}
